import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change (SPA)
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  return null;
}
